import styled from 'styled-components';
import responsive from 'utils/responsive';
import toRem from 'utils/toRem';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: ${({ colGap }) => toRem(colGap ?? 56)};
  row-gap: ${({ rowGap }) => toRem(rowGap ?? 56)};

  ${responsive('tabletSmall')} {
    grid-template-columns: repeat(${({ cols }) => cols || 1}, 1fr);
  }
`;

export default Grid;
